enum MoveProcessEnum {
  Up = 'UP',
  Down = 'DOWN',
}

export enum StringEnum {
  Lock = 'Lock',
}

export default MoveProcessEnum;
